import { render, staticRenderFns } from "./Bundle.vue?vue&type=template&id=179f33f2&scoped=true"
import script from "./Bundle.vue?vue&type=script&lang=js"
export * from "./Bundle.vue?vue&type=script&lang=js"
import style0 from "./Bundle.vue?vue&type=style&index=0&id=179f33f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179f33f2",
  null
  
)

export default component.exports